import { render, staticRenderFns } from "./DirectListHeader.vue?vue&type=template&id=712e1e09&scoped=true"
import script from "./DirectListHeader.vue?vue&type=script&lang=ts"
export * from "./DirectListHeader.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "712e1e09",
  null
  
)

export default component.exports